import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';

import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { Button } from './styles';

function InputColor({
  color,
  children,
  onChange,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [colorState, setColorState] = useState(color);

  const onChangeColor = (value) => {
    const { r, g, b, a } = value.rgb;
    setColorState(`rgba(${r}, ${g}, ${b}, ${a})`);
  };
  const onComplateColor = (value) => {
    const { r, g, b, a } = value.rgb;
    onChange(`rgba(${r}, ${g}, ${b}, ${a})`);
  };
  const onClicButton = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const onClosePopover = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Typography>{children}</Typography>
      <Box display="flex" mt={0.5}>
        <Button onClick={onClicButton} $background={colorState} />
        <TextField disabled value={colorState} variant="outlined" />
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <SketchPicker
          color={colorState}
          onChange={onChangeColor}
          onChangeComplete={onComplateColor}
        />
      </Popover>
    </>
  );
}

InputColor.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  color: PropTypes.string,
  onChange: PropTypes.func,
};

InputColor.defaultProps = {
  color: '',
  onChange: undefined,
};

export default InputColor;
